import React from 'react'
import PropTypes from 'prop-types'
import Text from '#components/a/Text'

export default function HintBox(props) {
  const {text = '', modifier = 'warning', dataTestId} = props
  const className = `hintbox hintbox--${modifier}`
  return (
    <div className={className} data-testid={dataTestId}>
      <div className="hintbox__icon" />
      <Text text={text} />
    </div>
  )
}

HintBox.propTypes = {
  text: PropTypes.string,
  modifier: PropTypes.string,
  dataTestId: PropTypes.string,
}
